import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { PoolsCollection } from './pools.types';

export function poolsBackend(): Backend<PoolsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/pools',
      params: {
        pools: ids,
        names: getQueryParamValue(query, 'name'),
        is_talent_network: getQueryParamValue(query, 'isTalentNetwork')[0],
        // We want to include all test pools for now.
        // This is because we don't have any specific logic around test pools as of yet.
        // Once we have a better picture of what that should be, then we may update this.
        ignore_test: false,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
